import { mapToCanActivate, Routes } from '@angular/router';
import { ProgramType, WCCTabsType } from '@core/model';
import { WCCPermissionsEnum } from '@core/constants/permissions.enum';
import { MsalGuard } from '@azure/msal-angular';
import { AccessPageGuard } from '@mynexus/mynexus-ui-lib';
import { DefaultWoundCareConnectComponent } from '@feature/default/default-wcc/default-wcc.component';

export const wccRoutes: Routes = [
  {
    path: 'wcc',
    data: { program: ProgramType.WCCAdmissions },
    children: [
      {
        path: 'pending-admissions',
        loadComponent: () => import('@feature/wound-care-connect/wcc-admissions-manager/wcc-admissions-manager.component')
          .then(i => i.WoundCareConnectReferralManagerComponent),
        data: {
          permissions: [WCCPermissionsEnum.Admission_Pending_Read],
          tab: WCCTabsType.PendingAdmissions
        },
        canActivate: mapToCanActivate([MsalGuard, AccessPageGuard])
      },
      {
        path: 'wcc-library',
        loadComponent: () => import('@feature/wound-care-connect/wcc-library-page/wcc-library-page.component')
          .then(i => i.WccLibraryPageComponent),
        data: {
          permissions: [WCCPermissionsEnum.Assessment_Read]
        },
        canActivate: mapToCanActivate([MsalGuard, AccessPageGuard])
      },
      {
        path: 'my-admissions',
        loadComponent: () => import('@feature/wound-care-connect/wcc-admissions-manager/wcc-admissions-manager.component')
          .then(i => i.WoundCareConnectReferralManagerComponent),
        data: {
          permissions: [WCCPermissionsEnum.Admission_Staffed_Read],
          tab: WCCTabsType.MyAdmissions
        },
        canActivate: mapToCanActivate([MsalGuard, AccessPageGuard])
      },
      {
        path: 'all-admissions',
        loadComponent: () => import('@feature/wound-care-connect/wcc-admissions-manager/wcc-admissions-manager.component')
          .then(i => i.WoundCareConnectReferralManagerComponent),
        data: {
          permissions: [WCCPermissionsEnum.Admission_All_Read],
          tab: WCCTabsType.AllAdmissions
        },
        canActivate: mapToCanActivate([MsalGuard, AccessPageGuard])
      },
      {
        path: 'archive-admissions',
        loadComponent: () => import('@feature/wound-care-connect/wcc-admissions-manager/wcc-admissions-manager.component')
          .then(i => i.WoundCareConnectReferralManagerComponent),
        data: {
          permissions: [WCCPermissionsEnum.Assessment_Read],
          tab: WCCTabsType.Archived
        },
        canActivate: mapToCanActivate([MsalGuard, AccessPageGuard])
      },
      {
        path: 'analytics',
        loadComponent: () => import('@feature/mfe-page/mfe-page.component').then(m => m.MfePageComponent),
        data: {
          appName: 'wcc',
          showDashboardNavigator: false,
          permissions: [WCCPermissionsEnum.Analytics_Read],
        },
        canActivate: mapToCanActivate([MsalGuard, AccessPageGuard])
      },
      {
        path: '',
        component: DefaultWoundCareConnectComponent,
        pathMatch: 'full',
        data: {
          permissions: [WCCPermissionsEnum.Assessment_Read],
        },
        canActivate: mapToCanActivate([MsalGuard, AccessPageGuard])
      },
    ]
  },
]
